import cx from "classnames";
import type { FC, ReactNode } from "react";

import styles from "./_.module.css";

export type PopOverMenuProps = {
	children: ReactNode;
	width?: "fixed" | "auto";
};

export const PopOverMenu: FC<PopOverMenuProps> = ({ children, width = "fixed" }) => {
	return (
		<ul
			className={cx(
				styles["popovermenu"],
				width === "fixed" ? styles["popovermenu-fixed"] : null
			)}
		>
			{children}
		</ul>
	);
};
